<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月10日 16:01:48 +0800
 * @最后修改时间: 2022-02-23 18:01:46
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimType\newClaimType.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_ClaimType_form_newTitle')"
    widthClass="max-1000"
    pad="0"
    :backgroundClass="curStep == 4 ? 'transparent' : ''"
    :initData="ClaimTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'claim_type_name',
      'claim_type_description',
      'claim_type_code',
      'claim_type_property_group_uuid',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper
        :curStep="curStep"
        :items="stepper"
        :contentClass="curStep == 4 ? 'mrc-grey pa-0' : 'white pa-8'"
      >
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation class="pa-2">
            <v-row class="white">
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="100"
                  :bindData="ClaimTypeData.claim_type_name"
                  @change="
                    (valueArr) => {
                      ClaimTypeData.claim_type_name = valueArr;
                    }
                  "
                  :label="$t('label_essweb_ClaimType_form_claimTypeNameLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
              /></v-col>
              <v-col md="3">
                <numberInputTextFiled
                  :label="$t('label_essweb_ClaimType_form_sequenceLabel')"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
                  "
                  maxlength="11"
                  v-model="ClaimTypeData.sequence"
                  :max="1000"
                  :min="0"
                  :placeholder="$t('label_essweb_ClaimType_form_sequenceLabel')"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimType_form_claimTypeCodeLabel')"
                  maxlength="100"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  v-model="ClaimTypeData.claim_type_code"
                  :placeholder="
                    $t('label_essweb_ClaimType_form_claimTypeCodeLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_ClaimType_form_claimTypePropertyGroupLabel")
                }}</v-sheet>
                <v-autocomplete
                  :items="ClaimTypePorpertyGroup"
                  item-text="claim_type_property_group_name"
                  item-value="uuid"
                  v-model="ClaimTypeData.claim_type_property_group_uuid"
                  append-icon="arrow_drop_down"
                  filled
                  single-line
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :placeholder="
                    $t(
                      'label_essweb_ClaimType_form_claimTypePropertyGroupLabel'
                    )
                  "
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="ClaimTypeData.claim_type_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      ClaimTypeData.claim_type_description = valueArr;
                    }
                  "
                  :label="$t('label_essweb_ClaimType_form_descriptionLabel')"
              /></v-col> </v-row></v-form
        ></template>
        <template v-slot:content-2>
          <Tabler
            :headers="claimTypeTransactionHeaders"
            :items="claimTypeTransactions"
            border
            :avPerPage="50"
          >
            <template v-slot:item.name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.claim_transaction_type_name) }}
              </div>
            </template>
            <template v-slot:item.code="{ item }">
              <div class="table-title text--primary">
                {{ item.claim_transaction_type_code }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="onEditTransactionType(item)">
                <span class="material-icons-round">edit</span>
              </v-btn>
              <v-btn icon @click="toDeleteTransactionType(item.uuid)">
                <span class="material-icons-round">delete</span>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider></v-divider>
                <v-btn
                  text
                  small
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="newTransactionTypeDialog = true"
                >
                  {{
                    $t(
                      "label_essweb_ClaimType_form_dialog_addClaimTypeTransactionTypeBtnLabel"
                    )
                  }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-3>
          <Tabler
            :headers="ApprovalFlowHeaders"
            :items="ApprovalFlows"
            border
            :avPerPage="50"
          >
            <template v-slot:item.amount="{ item }">
              <div class="table-title text--primary">≥{{ item.amount }}</div>
            </template>
            <template v-slot:item.name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.approval_flow_template_name) }}
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn icon @click="onEditApprovalFlow(item)">
                <span class="material-icons-round">edit</span>
              </v-btn>
              <v-btn icon @click="toDeleteApprovalFlow(item.uuid)">
                <span class="material-icons-round">delete</span>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider></v-divider>
                <v-btn
                  text
                  small
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="newApprovalFlowDialog = true"
                >
                  {{
                    $t(
                      "label_essweb_ClaimType_form_dialog_addapprovalFlowBtnLabel"
                    )
                  }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-4>
          <div class="max-width rounded-lg transparent">
            <v-tabs
              vertical
              v-model="lefttab"
              background-color="var(--taber-nav-color)"
              class="mrc-grey"
              hide-slider
            >
              <v-sheet height="8" width="200" class="rounded-t-lg"></v-sheet>
              <v-tab
                class="white text-capitalize px-3 mr-2 text-left text-truncate"
                style="width: 200px"
                :class="lefttab == 0 ? 'primary lighten-5 text--primary' : ''"
              >
                <div class="max-width text-left text-truncate">
                  {{ $t("label_essweb_ClaimType_form_tab_beforeNoticeLabel") }}
                </div></v-tab
              >
              <v-tab
                class="white text-capitalize px-3 mr-2 text-left text-truncate"
                style="width: 200px"
                :class="lefttab == 1 ? 'primary lighten-5 text--primary' : ''"
                ><div class="max-width text-left text-truncate">
                  {{ $t("label_essweb_ClaimType_form_tab_afterNoticeLabel") }}
                </div></v-tab
              >
              <v-sheet height="8" width="200" class="rounded-b-lg"></v-sheet>
              <v-tab-item class="mrc-grey">
                <v-card class="white" :elevation="0">
                  <v-card-text class="transparent pa-8">
                    <v-container fluid class="mrc-grey rounded-lg">
                      <!-- <draggable
              v-model="dragArr"
              draggable=".drag"
              v-bind="{ animation: 1000 }"
              :list="NoticeList"
            >-->
                      <v-sheet
                        class="rounded-lg pa-0 drag my-2"
                        v-for="(item, index) in beforeNoticeList"
                        :key="index"
                      >
                        <v-hover v-slot:default="{ hover }" open-delay="100">
                          <v-card
                            class="pa-2 d-flex rounded-lg align-center"
                            :elevation="hover ? 4 : 2"
                          >
                            <svg-icon
                              size="36"
                              fill="grey"
                              iconClass="dragvertical"
                              style="min-width: 36px"
                            />
                            <svg-icon
                              size="36"
                              fill="black"
                              iconClass="arrow01"
                              style="min-width: 36px"
                            />
                            <span class="text-body-2">
                              {{
                                $getCommonLangValue(
                                  item["claim_type_notice_point_" + item.number]
                                )
                              }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn
                              icon
                              small
                              v-if="hover"
                              @click="toEditNotice(item, 'before')"
                            >
                              <span class="material-icons-round">edit</span>
                            </v-btn>
                            <v-btn
                              icon
                              small
                              v-if="hover"
                              @click="onDeleteNotice(item.number, 'before')"
                            >
                              <span class="material-icons-round">delete</span>
                            </v-btn>
                          </v-card>
                        </v-hover>
                      </v-sheet>
                      <!-- </draggable> -->
                    </v-container>
                    <v-form ref="form2">
                      <v-row>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <v-checkbox
                            v-model="before_is_required_acknowledgement"
                            :label="
                              $t(
                                'label_essweb_ClaimType_form_noticeRequireLabel'
                              )
                            "
                            required
                          ></v-checkbox>
                        </v-col>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <inputTextFiledMultiLang
                            :bindData="before_acknowledge"
                            maxlength="100"
                            @change="
                              (valueArr) => {
                                before_acknowledge = valueArr;
                              }
                            "
                            :label="
                              $t('label_essweb_ClaimType_form_acknowledgeLabel')
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text> </v-card
              ></v-tab-item>
              <v-tab-item class="mrc-grey">
                <v-card class="white" :elevation="0">
                  <v-card-text class="transparent pa-8">
                    <v-container fluid class="mrc-grey rounded-lg">
                      <!-- <draggable
              v-model="dragArr"
              draggable=".drag"
              v-bind="{ animation: 1000 }"
              :list="NoticeList"
            >-->
                      <v-sheet
                        class="rounded-lg pa-0 drag mt-2 mb-2"
                        v-for="(item, index) in afterNoticeList"
                        :key="index"
                      >
                        <v-hover v-slot:default="{ hover }" open-delay="100">
                          <v-card
                            class="pa-2 d-flex rounded-lg align-center"
                            :elevation="hover ? 4 : 2"
                          >
                            <svg-icon
                              size="36"
                              fill="grey"
                              iconClass="dragvertical"
                              style="min-width: 36px"
                            />
                            <svg-icon
                              size="36"
                              fill="black"
                              iconClass="arrow01"
                              style="min-width: 36px"
                            />
                            <span class="text-body-2">
                              {{
                                $getCommonLangValue(
                                  item["claim_type_notice_point_" + item.number]
                                )
                              }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn
                              icon
                              small
                              v-if="hover"
                              @click="toEditNotice(item, 'after')"
                            >
                              <span class="material-icons-round">edit</span>
                            </v-btn>
                            <v-btn
                              icon
                              small
                              v-if="hover"
                              @click="onDeleteNotice(item.number, 'after')"
                            >
                              <span class="material-icons-round">delete</span>
                            </v-btn>
                          </v-card>
                        </v-hover>
                      </v-sheet>
                      <!-- </draggable> -->
                    </v-container>
                    <v-form ref="form3">
                      <v-row>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <v-checkbox
                            v-model="after_is_required_acknowledgement"
                            :label="
                              $t(
                                'label_essweb_ClaimType_form_noticeRequireLabel'
                              )
                            "
                            required
                          ></v-checkbox>
                        </v-col>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <inputTextFiledMultiLang
                            :bindData="after_acknowledge"
                            :rules="$GetRules(['_Require_Rules'], [null])"
                            @change="
                              (valueArr) => {
                                after_acknowledge = valueArr;
                              }
                            "
                            :label="
                              $t('label_essweb_ClaimType_form_acknowledgeLabel')
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text> </v-card
              ></v-tab-item>
            </v-tabs>
          </div>
        </template>
        <template v-slot:content-5>
          <Tabler
            :headers="claimTypeItemHeaders"
            :items="claimTypeItems"
            border
            :avPerPage="50"
          >
            <template v-slot:item.name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.claim_item_type_name) }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="toDeleteClaimItem(item.uuid)">
                <span class="material-icons-round">delete</span>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider></v-divider>
                <v-btn
                  text
                  small
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="
                    curSelectClaimItem = claimTypeItems;
                    newClaimItemDialog = true;
                  "
                >
                  {{
                    $t(
                      "label_essweb_ClaimType_form_dialog_addClaimItemBtnLabel"
                    )
                  }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :style="{
          marginLeft: curStep == 4 ? '208px' : '0px',
          width: curStep == 4 ? 'calc(100% - 208px)' : '100%',
        }"
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :onLoading="isLoading"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <newClaimTransactionType
        :show="newTransactionTypeDialog"
        @close="
          newTransactionTypeDialog = false;
          curPropertyData = null;
        "
        @onNew="onNewTransactionType"
        :PropertyData="curPropertyData"
      />
      <newApprovalFlow
        :show="newApprovalFlowDialog"
        @close="
          newApprovalFlowDialog = false;
          curflowPropertyData = null;
        "
        @onNew="onNewApprovalFlow"
        :PropertyData="curFlowPropertyData"
      />
      <newNotice
        :show="showNewNotice"
        @close="
          showNewNotice = false;
          NoticePropertyData = null;
        "
        :PropertyData="NoticePropertyData"
        @onNew="onNewNotice"
      />
      <newClaimItem
        :show="newClaimItemDialog"
        @close="newClaimItemDialog = false"
        @onSave="onEditClaimItem"
        :PorpertyData="curSelectClaimItem"
      />
      <!-- 
      <editClaimFieldDialog
        :show="editFeildDialog"
        :mappingData="curMapping"
        @close="editFeildDialog = false"
        @onEdit="onEditClaimField"
      /> -->
    </template>
  </ContentLayout>
</template>
<script>
import newClaimTransactionType from "@/Page/EssAdmin/Claim/ClaimType/components/newClaimTransactionType.vue";
import editClaimFieldDialog from "@/Page/EssAdmin/Claim/ClaimType/components/editClaimFieldDialog.vue";
import newApprovalFlow from "@/Page/EssAdmin/Claim/ClaimType/components/newApprovalFlow.vue";
import editApprovalFlow from "@/Page/EssAdmin/Claim/ClaimType/components/editApprovalFlow.vue";
import newNotice from "@/Page/EssAdmin/Claim/ClaimType/components/newNotice";
import newClaimItem from "@/Page/EssAdmin/Claim/ClaimType/components/newClaimItem";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import draggable from "vuedraggable";
export default {
  name: "newClaimType",
  components: {
    draggable,
    newClaimTransactionType,
    editClaimFieldDialog,
    editApprovalFlow,
    newApprovalFlow,
    newNotice,
    newClaimItem,
  },
  computed: {
    ...mapGetters(["companyLang", "isLoading"]),
    ClaimTypePorpertyGroup() {
      return this.$getSelectTrans(
        this.ClaimTypePorpertyGroupData,
        "claim_type_property_group_name"
      );
    },
  },
  data() {
    return {
      curStep: 1,
      isChanged: false,
      curSelectClaimItem: null,
      newTransactionTypeDialog: false,
      before_is_required_acknowledgement: 0,
      after_is_required_acknowledgement: 0,
      showNewNotice: false,
      newClaimItemDialog: false,
      curEditType: null,
      before_acknowledge: "",
      after_acknowledge: "",
      newApprovalFlowDialog: false,
      curPropertyData: null,
      NoticePropertyData: null,
      beforeNoticeList: [],
      afterNoticeList: [],
      curFlowPropertyData: null,
      stepper: [
        "label_essweb_ClaimType_form_tag_GeneralLabel",
        "label_essweb_ClaimType_form_tag_claimTransactionTypeLabel",
        "label_essweb_ClaimType_form_tag_approvalFlowLabel",
        "label_essweb_ClaimType_form_tag_noticeLabel",
        "label_essweb_ClaimType_form_tag_claimItemLabel",
      ],
      lefttab: 0,
      showNewTranType: false,
      curTranTypeUuid: null,
      showEditTranType: false,
      ClaimTypePorpertyGroupData: [],
      claimTypeTransactionHeaders: [
        {
          text: "label_essweb_ClaimType_form_claimTypeTransactionTypeNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimType_form_claimTypeTransactionTypeCodeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      ApprovalFlowHeaders: [
        {
          text: "label_essweb_ClaimType_form_approvalClaimAmountLabel",
          value: "amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimType_form_approvalClaimTemplateNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      claimTypeTransactions: [],
      claimTypeItemHeaders: [
        {
          text: "label_essweb_ClaimType_form_claimItemLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      claimTypeItems: [],
      ApprovalFlows: [],
      willClearNotice: null,
      curApprovalUuid: null,
      showApprovalFlow: false,
      showNewApprovalFlow: false,
      ClaimTypeData: {
        claim_type_name: "",
        sequence: 1,
        claim_type_description: "",
        claim_type_code: "",
        claim_type_property_group_uuid: "",
      },
    };
  },
  watch: {
    newClaimItemDialog() {
      const that = this;
      this.curSelectClaimItem = null;
      this.$Sleep(300).then(() => {
        that.curSelectClaimItem = that.claimTypeItems;
      });
    },
  },
  mounted() {
    const that = this;
    this.beforeNoticeList = [];
    this.afterNoticeList = [];
    for (let i = 0; i < 5; i++) {
      let json = {};
      json["claim_type_notice_point_" + (i + 1)] = this.$transCommonLangKey(
        this.$getCommonLangKey(this.companyLang)
      );

      json["number"] = i + 1;
      let obj1 = JSON.parse(JSON.stringify(json)); //深拷贝
      this.beforeNoticeList.push(obj1);
      let obj2 = JSON.parse(JSON.stringify(json)); //深拷贝
      this.afterNoticeList.push(obj2);
    }
    this.getClaimTypePropertyGroup();
    // this.ClaimTypeData.claim_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.ClaimTypeData.claim_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
  },
  methods: {
    toDeleteClaimItem: function (uuid) {
      const that = this;
      this.$confirmDo(
        this.$t("label_essweb_ClaimType_form_tag_claimItemLabel")
      ).then((res) => {
        if (res)
          that.claimTypeItems = that.claimTypeItems.filter(
            (ele) => ele.uuid !== uuid
          );
      });
    },
    onEditClaimItem: function (select) {
      this.newClaimItemDialog = false;
      this.claimTypeItems = select;
    },
    toEditNotice: function (obj, type) {
      this.curEditType = type;
      this.NoticePropertyData = obj;
      this.showNewNotice = true;
    },
    onDeleteNotice: function (number, type) {
      const that = this;
      this.willClearNotice = number;
      this.$confirmDo(
        this.$t("label_essweb_ClaimType_form_tag_noticeLabel")
      ).then((res) => {
        if (res) that.toClearNotice(type);
      });
    },
    toClearNotice: function (type) {
      const that = this;
      if (type === "before") {
        this.beforeNoticeList.map((item) => {
          if (item.number == that.willClearNotice) {
            item["claim_type_notice_point_" + that.willClearNotice] =
              that.$transCommonLangKey(
                that.$getCommonLangKey(that.companyLang)
              );
          }
        });
      } else {
        this.afterNoticeList.map((item) => {
          if (item.number == that.willClearNotice) {
            item["claim_type_notice_point_" + that.willClearNotice] =
              that.$transCommonLangKey(
                that.$getCommonLangKey(that.companyLang)
              );
          }
        });
      }
    },
    onNewNotice: function (notice, number) {
      this.NoticePropertyData = null;
      if (this.curEditType === "before") {
        this.beforeNoticeList.map((item) => {
          if (item.number == number) {
            item["claim_type_notice_point_" + number] =
              this.$transCommonLangKey(notice);
          }
        });
      } else {
        this.afterNoticeList.map((item) => {
          if (item.number == number) {
            item["claim_type_notice_point_" + number] =
              this.$transCommonLangKey(notice);
          }
        });
      }
      this.showNewNotice = false;
    },
    toDeleteTransactionType: function (uuid) {
      const that = this;
      this.$confirmDo(
        this.$t("label_essweb_ClaimType_form_tag_claimTransactionTypeLabel")
      ).then((res) => {
        if (res) {
          that.claimTypeTransactions = that.claimTypeTransactions.filter(
            (ele) => ele.uuid !== uuid
          );
        }
      });
    },
    toDeleteApprovalFlow: function (uuid) {
      const that = this;
      this.$confirmDo(
        this.$t("label_essweb_ClaimType_form_tag_approvalFlowLabel")
      ).then((res) => {
        if (res) {
          that.ApprovalFlows = that.ApprovalFlows.filter(
            (ele) => ele.uuid !== uuid
          );
        }
      });
    },
    getClaimTypePropertyGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_property_group",
        url: "/claim-type-property-group/get-list/",
      }).then((res) => {
        that.ClaimTypePorpertyGroupData = res.data;
      });
    },
    onEditApprovalFlow: function (obj) {
      const that = this;
      this.curFlowPropertyData = null;
      this.$Sleep(300).then(() => {
        that.curFlowPropertyData = obj;
        that.newApprovalFlowDialog = true;
      });
    },
    onNewApprovalFlow: function (obj) {
      const that = this;
      this.curFlowPropertyData = null;
      if (obj) {
        if (!obj["uuid"]) {
          // 新增
          obj["uuid"] = dayjs().valueOf();
          // obj["approval_flow_template_name"] = this.$transCommonLangKey(
          //   obj["approval_flow_template_name"]
          // );
          this.ApprovalFlows.push(obj);
        } else {
          //修改
          // obj["approval_flow_template_name"] = this.$transCommonLangKey(
          //   obj["approval_flow_template_name"]
          // );
          this.ApprovalFlows.some((item, index) => {
            if (item.uuid === obj["uuid"]) {
              that.ApprovalFlows.splice(index, 1, obj);
              return true;
            }
          });
        }
      }
      this.newApprovalFlowDialog = false;
    },
    onEditTransactionType: function (obj) {
      this.curPropertyData = obj;
      this.newTransactionTypeDialog = true;
    },
    onNewTransactionType: function (obj) {
      const that = this;
      this.curPropertyData = null;
      if (obj) {
        if (!obj["uuid"]) {
          // 新增
          obj["uuid"] = dayjs().valueOf();
          obj["claim_transaction_type_name"] = this.$transCommonLangKey(
            obj["claim_transaction_type_name"]
          );
          obj["claim_transaction_type_description"] = this.$transCommonLangKey(
            obj["claim_transaction_type_description"]
          );
          this.claimTypeTransactions.push(obj);
        } else {
          //修改
          obj["claim_transaction_type_name"] = this.$transCommonLangKey(
            obj["claim_transaction_type_name"]
          );
          obj["claim_transaction_type_description"] = this.$transCommonLangKey(
            obj["claim_transaction_type_description"]
          );
          this.claimTypeTransactions.some((item, index) => {
            if (item.uuid === obj["uuid"]) {
              that.claimTypeTransactions.splice(index, 1, obj);
              return true;
            }
          });
        }
      }
      this.newTransactionTypeDialog = false;
    },
    toNext: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      if (this.curStep == 1) {
        this.lefttab = 1;
      }
      if (this.curStep == 2) {
        this.lefttab = 0;
      }
      if (this.curStep == 3) {
        this.lefttab = 0;
      }
      if (this.curStep == 4) {
        if (!this.$refs["form2"].validate()) {
          this.$showMessage({
            title: this.$t("message_essweb_form_textField_noticeTitle"),
            okText: this.$t("message_essweb_form_textField_fillInAgain"),
            text: this.$t("message_essweb_form_textField_notIncorrect_content"),
            type: "warning",
          });
          return false;
        }
        if (this.$refs["form3"]) {
          if (!this.$refs["form3"].validate()) {
            this.lefttab = 1;
            this.$showMessage({
              title: this.$t("message_essweb_form_textField_noticeTitle"),
              okText: this.$t("message_essweb_form_textField_fillInAgain"),
              text: this.$t(
                "message_essweb_form_textField_notIncorrect_content"
              ),
              type: "warning",
            });
            return false;
          }
        }
      }
      this.curStep = this.curStep + 1;
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let ess_clm_claim_transaction_type = JSON.parse(
        JSON.stringify(this.claimTypeTransactions)
      );
      let ess_clm_claim_type_approval_condition = JSON.parse(
        JSON.stringify(this.ApprovalFlows)
      );
      let ess_clm_claim_type_before_notice_save = JSON.parse(
        JSON.stringify(this.beforeNoticeList)
      );
      let ess_clm_claim_type_before_notice = {};
      let ess_clm_claim_type_after_notice_save = JSON.parse(
        JSON.stringify(this.afterNoticeList)
      );
      let ess_clm_claim_type_after_notice = {};
      let ess_clm_claim_item_type = JSON.parse(
        JSON.stringify(this.claimTypeItems)
      );

      ess_clm_claim_transaction_type.map((item) => {
        if (item["uuid"]) delete item["uuid"];
      });
      ess_clm_claim_type_approval_condition.map((item) => {
        if (item["uuid"]) delete item["uuid"];
      });
      ess_clm_claim_type_before_notice_save.map((item) => {
        ess_clm_claim_type_before_notice[
          "claim_type_notice_point_" + item.number
        ] = item["claim_type_notice_point_" + item.number];
        // if (item["number"]) delete item["number"];
      });
      ess_clm_claim_type_after_notice_save.map((item) => {
        ess_clm_claim_type_after_notice[
          "claim_type_notice_point_" + item.number
        ] = item["claim_type_notice_point_" + item.number];
        // if (item["number"]) delete item["number"];
      });
      ess_clm_claim_type_before_notice["is_required_acknowledgement"] =
        this.before_is_required_acknowledgement;
      ess_clm_claim_type_after_notice["is_required_acknowledgement"] =
        this.after_is_required_acknowledgement;
      ess_clm_claim_type_after_notice["is_required_acknowledgement"] =
        this.after_is_required_acknowledgement;
      ess_clm_claim_type_before_notice["acknowledge_content"] =
        this.$transCommonLangKey(this.before_acknowledge);
      ess_clm_claim_type_after_notice["acknowledge_content"] =
        this.$transCommonLangKey(this.after_acknowledge);
      ess_clm_claim_item_type.map((item) => {
        item["claim_item_type_uuid"] = item["uuid"];
        if (item["uuid"]) delete item["uuid"];
      });
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type",
        url: "/claim-type/add-claim-type-table/",
        data: {
          claim_type_name: this.$transCommonLangKey(
            this.ClaimTypeData.claim_type_name
          ),
          claim_type_description: this.$transCommonLangKey(
            this.ClaimTypeData.claim_type_description
          ),
          claim_type_code: this.ClaimTypeData.claim_type_code,
          sequence: this.ClaimTypeData.sequence,
          claim_type_property_group_uuid:
            this.ClaimTypeData.claim_type_property_group_uuid,
          ess_clm_claim_transaction_type: ess_clm_claim_transaction_type,
          ess_clm_claim_type_approval_condition:
            ess_clm_claim_type_approval_condition,
          ess_clm_claim_type_before_notice: [ess_clm_claim_type_before_notice],
          ess_clm_claim_type_after_notice: [ess_clm_claim_type_after_notice],
          ess_clm_map_claim_type_claim_item_type: ess_clm_claim_item_type,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    toNewMapping: function () {
      const that = this;
      this.newFeildDialog = true;
    },
    toEditMapping: function (item) {
      const that = this;
      this.editFeildDialog = true;
      this.curMapping = null;
      this.curMapping = item;
    },
    toDeleteProperty: function (obj) {
      const that = this;
      this.showPGDelete = true;
      this.curPropertyObj = obj;
    },
    toDeletePG: function () {
      const that = this;
      this.showPGDelete = false;
      const index = this.deserts.indexOf(this.curPropertyObj);
      if (index >= 0) {
        this.deserts.splice(index, 1);
      }
    },
  },
};
</script>
